export const DEFAULT_FORM_DATA = {
  description: "",
  name: "",
  extra_choices: [{label: "", value: ""}],
  order_alphabetically: false,
};
